import { useQuery } from '@tanstack/react-query';
import { strapiFetchUserDetail } from '../../api/strapiUsers';
import { queryKeys } from '../queryKeys';

export function useUserDetailQuery(jwt: string | null, id: string | null | undefined) {
  return useQuery({
    queryKey: queryKeys.userDetail(jwt, id ?? null),
    queryFn: () => strapiFetchUserDetail(jwt!, id!),
    enabled: Boolean(jwt && id && Number.isFinite(Number(id))),
  });
}
